module.exports = __webpack_public_path__ + "media/images/icons/logo-sqs-562fa6ac945c692038fe78976578287f.png";